import { render, staticRenderFns } from "./AccountTemplates.vue?vue&type=template&id=3c37d0f3&scoped=true&"
import script from "./AccountTemplates.vue?vue&type=script&lang=js&"
export * from "./AccountTemplates.vue?vue&type=script&lang=js&"
import style0 from "./AccountTemplates.vue?vue&type=style&index=0&id=3c37d0f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c37d0f3",
  null
  
)

export default component.exports